export const analyticsEvents = {
  page_view: "page_view",
  route_change: "route_change",
  scroll_depth: "scroll_depth",
  engagement_time: "engagement_time",
  element_view: "element_view",
  click_zone: "click_zone",
  dead_click: "dead_click",
  outbound_click: "outbound_click",

  view_sticker_pack: "view_sticker_pack",
  download_click: "download_click",
  share_click: "share_click",
  share_expand: "share_expand",

  search_focus: "search_focus",
  search_typed: "search_typed",
  search_submit: "search_submit",
  search_result_click: "search_result_click",

  hashtag_click: "hashtag_click",
  category_click: "category_click",

  contact_submit: "contact_submit",
  partnership_submit: "partnership_submit",

  app_prompt_open: "app_prompt_open",
  app_prompt_cta_click: "app_prompt_cta_click",
  app_install_click: "app_install_click",
  app_deeplink_redirect: "app_deeplink_redirect",

  ad_slot_view: "ad_slot_view",
  ad_slot_unfilled: "ad_slot_unfilled",
  ad_intervention: "ad_intervention",

  web_vital: "web_vital",
  js_error: "js_error",
  consent_choice: "consent_choice",
} as const;

export type AnalyticsEvent = (typeof analyticsEvents)[keyof typeof analyticsEvents];
